import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';
import type { Action, ActiveCampaign, ThunkAction } from 'types';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';

import { sortBy } from 'lodash';

const TAGS_LOADED = 'realmOutfitsTags/TAGS_LOADED';
const TAGS_RESET = 'realmOutfitsTags/TAGS_RESET';

const { REALM_OUTFITS } = API.END_POINTS;

const initialState = {
  tags: []
};

function realmOutfitsTagsLoaded(data: Array<ActiveCampaign>): Action {
  return {
    type: TAGS_LOADED,
    payload: {
      data
    }
  };
}

export function resetRealmOutfitsTags(): Action {
  return {
    type: TAGS_RESET
  };
}

export function fetchRealmOutfitsTags(): ThunkAction {
  return (dispatch) => {
    const url = REALM_OUTFITS.getOutfitsTags();

    return get(url)
      .then((response) => {
        const sortedData = sortBy(response.data, tag => tag.title);

        dispatch(realmOutfitsTagsLoaded(sortedData));
      })
      .catch((error) => {
        logError(error);
      });
  };
}

export default createReducer<any, any>('realmOutfitsTags', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [TAGS_LOADED]: (state, { data }) => ({
    ...state,
    tags: data
  }),
  [TAGS_RESET]: () => (initialState)
});
